import isNil from 'lodash/isNil'
import OLGeomPoint from 'ol/geom/Point'

/**
 * Get extents coords in correct order and format for the openlayers view extents params.
 * https://openlayers.org/en/latest/apidoc/module-ol_View-View.html
 *
 * @param {array} bbox [[lng,lat][lng,lat]]
 * @param {bool} bReturn4326Coords If true returns bbox coords as 4326 rather than 3857
 */
export default function (bbox, bReturn4326Coords = false) {
  let minLng = -180
  let minLat = -90
  let maxLng = 180
  let maxLat = 90

  if (isNil(bbox) || bbox.length !== 2) {
    return convertCoords(minLng, minLat, maxLng, maxLat)
  }

  const lngA = bbox[0][0]
  const latA = bbox[0][1]
  const lngB = bbox[1][0]
  const latB = bbox[1][1]

  if (lngA < lngB) {
    minLng = lngA
    maxLng = lngB
  } else {
    minLng = lngB
    maxLng = lngA
  }
  if (latA < latB) {
    minLat = latA
    maxLat = latB
  } else {
    minLat = latB
    maxLat = latA
  }

  sanityCheck(minLng, minLat, maxLng, maxLat)
  return convertCoords(minLng, minLat, maxLng, maxLat, bReturn4326Coords)
}

function convertCoords (minLng, minLat, maxLng, maxLat, bReturn4326Coords) {
  let minCoords
  let maxCoords
  if (bReturn4326Coords) {
    minCoords = new OLGeomPoint([parseFloat(minLng), parseFloat(minLat)]).getCoordinates()
    maxCoords = new OLGeomPoint([parseFloat(maxLng), parseFloat(maxLat)]).getCoordinates()
  } else {
    minCoords = new OLGeomPoint([parseFloat(minLng), parseFloat(minLat)]).transform('EPSG:4326', 'EPSG:3857').getCoordinates()
    maxCoords = new OLGeomPoint([parseFloat(maxLng), parseFloat(maxLat)]).transform('EPSG:4326', 'EPSG:3857').getCoordinates()
  }
  return [minCoords[0], minCoords[1], maxCoords[0], maxCoords[1]]
}

function sanityCheck (minLng, minLat, maxLng, maxLat) {
  if (minLng < -180 || minLng > 180) {
    minLng = -180
  }
  if (minLat < -90 || minLat > 90) {
    minLat = -90
  }
  if (maxLng < -180 || maxLng > 180) {
    maxLng = 180
  }
  if (maxLat < 90 || maxLat > 90) {
    maxLat = 90
  }
}
